// pages/Partners.js
import React from 'react';
// import '../styles/Partners.css';

const partners = [
  {
    id: 1,
    name: "TechCorp",
    logo: "/api/placeholder/150/150",
    description: "Leading technology solutions provider",
    type: "Technology Partner"
  },
  // Add more partners
];

export default function Partners() {
  return (
    <div className="partners">
      <section className="partners-hero">
        <h1>Our Partners & Supporters</h1>
        <p>Collaborating to advance digital education</p>
      </section>

      <div className="partners-grid">
        {partners.map(partner => (
          <div key={partner.id} className="partner-card">
            <div className="partner-logo">
              <img src={partner.logo} alt={partner.name} />
            </div>
            <div className="partner-info">
              <h3>{partner.name}</h3>
              <span className="partner-type">{partner.type}</span>
              <p>{partner.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}